import React from 'react'
import FiltersUpdate from './FiltersUpdate'
import swal from 'sweetalert'
import { capitalize } from '../helpers'
import {
  sortableContainer,
  sortableElement,
  sortableHandle
} from 'react-sortable-hoc';

const DragHandle = sortableHandle(() => <i className="material-icons drag-cursor mr-10">drag_handle</i>);

const Item = sortableElement(props => {
  const {
    condition, isHidden, operators, valid_operators, removeFilter, removeCondition, getFiltered,
    hasUpdate, report_id, removeOperation, index, current_condition, setCurrentConditon
  } = props
  const { filters, operations } = condition

  const editing = (condition.id === current_condition.id)

  return (
    <div className={isHidden ? 'hide' : `row condition-row ${editing ? 'row-editing' : ''}`}>
      <div className="col s10 l10 xl10" style={{paddingTop: 20}}>
        <div className="col s6 l6 xl6 col44 filters-part">
          {
            filters.map( (filter) => {
              const {key, field, operator, value} = filter
              const fieldName = (["created_at", "updated_at"].indexOf(field) > -1 ) ? ((field === "created_at" ) ? "Date Added" : "Date Updated") : ( field==="newentry" ? "New Entry" : capitalize(field) )

              const operatorName = capitalize( Object.keys(operators).filter(function(key) {return operators[key] === operator })[0] )

              let valueName = value
              if (typeof(value) === "object" && !(value instanceof Date)) {
                valueName = "[ " + value.join(' | ') + " ]"
              } else if (value instanceof Date) {
                valueName = value.toLocaleDateString()
              }

              const hiddenOperators = ["true", "false", "~", "!~", true, false, "off", "on"]

              const valueClass = ( hiddenOperators.indexOf(operator) < 0 ) ? "valueColumn" : "hide"

              return (
                <div className="row" key={key}>
                  <div className="col s1">
                    <a href="" onClick={(e) => {
                      e.preventDefault()
                      removeFilter(condition.id, key)
                    }}>
                      <i className="material-icons c-red" title="Remove Filter">cancel</i>
                    </a>
                  </div>
                  <div className="col s11 filtersColumn">
                    <span className="fieldColumn mr15">{fieldName}</span>
                    <span className="operatorColumn mr15">{operatorName}</span>
                    <span className={valueClass}>{valueName}</span>
                  </div>
                </div>
              )
            }
          )}
        </div>

        <div className="col s6 l6 xl6 col44 operations-part">
          {
            // (hasUpdate && filters.length > 0) && (
              (<FiltersUpdate
                report_id={report_id}
                operations={operations}
                filters={filters}
                removeOperation={removeOperation}
                condition_id={condition.id}
              />)
            // )
          }
        </div>
      </div>
      <div className="col s2 l2 xl2 counter-part">
        <DragHandle />
        <a href="" title="Drag and drop to rearrange (top-down)" className="mr-10" onClick={(e) => {
          e.preventDefault()
          removeCondition(condition.id)
        }}>
          <i className="material-icons c-red" title="Remove Condition">cancel</i>
        </a>
        <a href="" className="mr-10" onClick={(e) => {
          e.preventDefault()
          getFiltered(condition.filters)
        }}>
          <i className="material-icons c-red" title="Apply filters">filter_list</i>
        </a>
        <label style={{verticalAlign: 'top'}}>
          <input name="now_editing" className="with_gap" type="radio" value={condition.id} checked={editing} onClick={e => {
            setCurrentConditon(condition.id)
          }}/>
          <span>Edit</span>
        </label>
      </div>

    </div>
  )
});

const SortableContainer = sortableContainer((props) => {
  return (
    <div className="row" style={{margin: '0 1px 0 0'}}>
      <div className="col s11 l11 xl11" style={{paddingLeft: 0}}>
        {props.children}
      </div>
    </div>
  )
})

class SortableConditions extends React.Component {

  batchUpdate() {
    this.props.batchUpdate()
  }

  dryBatchUpdate() {
    this.props.batchUpdate(true)
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    document.body.classList.remove("currently-dragging");
    this.props.reArrange(oldIndex, newIndex)
  }
  onSortStart = e => {
    document.body.classList.add("currently-dragging");
  }

  render() {
    const { conditions, reArrange, ...other } = this.props
    const dry_disabled = conditions.filter( c => c.operations.length > 0 && c.filters.length > 0 ).length === 0
    const run_disabled = conditions.filter( c => c.filters.length > 0 ).length === 0

    return (
      <React.Fragment>
        <SortableContainer onSortEnd={this.onSortEnd} onSortStart={this.onSortStart} useDragHandle>
          {
            conditions.map( (condition, index) => {
              if ( condition.filters.length === 0 && condition.operations.length === 0 ) {
                return (
                  <div className={this.props.isHidden ? 'hide' : `row condition-row`} key={condition.id}>
                    <div className="col s11 l11 xl11">
                      <div style={{color: 'darkgrey'}}>Start adding filtering rules</div>
                    </div>
                  </div>
                )
              }
              return (
                <Item {...other} condition={condition} key={condition.id} index={index}/>
              )
            })
          }
        </SortableContainer>

        <div className="row">
          <div className={this.props.isHidden ? 'hide' : 'col s12 l12 xl12 filtersrun'}>

            <a href="" className="btn red darken-1 waves-effect waves-light mr-10" disabled={dry_disabled} onClick={(e)=>{
              e.preventDefault()
              this.dryBatchUpdate()
            }}><i className="material-icons right">security</i>Dry run</a>

            <a href="" className="btn red darken-1 waves-effect waves-light" disabled={run_disabled} title="Filtering is based on last condition" onClick={(e)=>{
              e.preventDefault()
              swal({
                title: "Apply operations?",
                text: `Are you sure that you want to apply these operations?\nThis cannot be undone.`,
                icon: "warning",
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    className: "btn red darken-1 waves-effect waves-light",
                    closeModal: true,
                  },
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "btn red darken-1 waves-effect waves-light",
                    closeModal: true
                  }
                },
                // dangerMode: true
              }).then(willDelete => {
                if (willDelete) {
                  this.batchUpdate()
                }
              });
            }}><i className="material-icons right mr-10">done_all</i>Filter & Apply</a>

          </div>
        </div>

      </React.Fragment>
    )
  }
}

export default SortableConditions



// WEBPACK FOOTER //
// ./src/js/components/SortableConditions.js